/** Compara versiones semánticas "1.2.3". Devuelve >0 si a > b. */
export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map((n) => parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
}

/**
 * Actualización escalonada: un equipo entra en el rollout si su "balde" (hash estable
 * de su fingerprint, 0–99) es menor al porcentaje publicado.
 */
export function inRollout(fingerprint: string, pct: number): boolean {
  let h = 0;
  for (const ch of fingerprint) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h % 100 < pct;
}
